import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import ThirdPartyVerificationFieldsSections from '../../../../../reusableFormFields/ThirdPartyVerificationFieldsSections'

import { OPTION_NO, OPTION_YES } from '../../../../../../../constants/forms'
import { APPLY_THIRD_PARTY_VERIFIER, CUSTOM_SEGMENT_IDS } from '../../fields'

const stepFields = [CUSTOM_SEGMENT_IDS]

const ThirdPartyVerificationStep = ({ formik, handleStepChange }) => {
  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields, values)
  }, [handleStepChange, values])

  return (
    <Step stepTitle="Would you like to apply IAS brand safety targeting" handleContinue={handleContinue}>
      <RadioBlock
        setFieldValue={setFieldValue}
        id={APPLY_THIRD_PARTY_VERIFIER + OPTION_NO}
        name={APPLY_THIRD_PARTY_VERIFIER}
        value={OPTION_NO}
        selectedValue={values[APPLY_THIRD_PARTY_VERIFIER]}
        label={t('No')}
      />
      <RadioBlock
        setFieldValue={setFieldValue}
        id={APPLY_THIRD_PARTY_VERIFIER + OPTION_YES}
        name={APPLY_THIRD_PARTY_VERIFIER}
        value={OPTION_YES}
        selectedValue={values[APPLY_THIRD_PARTY_VERIFIER]}
        label={t('Yes')}
      >
        <ThirdPartyVerificationFieldsSections formik={formik} />
      </RadioBlock>
    </Step>
  )
}

export default ThirdPartyVerificationStep
